export default __webpack_public_path__ + "6f246380a2e272436e4a7a55e4a43574.png";